'use strict';

exports = module.exports = require('./lib/parser')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./~/intl-messageformat/~/intl-messageformat-parser/index.js
// module id = 1020
// module chunks = 3